appSocial.component('tradeExpanded', {
    templateUrl: 'widgets/leader-detail/components/trade-expanded/TradeExpandedComponent.html',
    bindings: {
        trade: '<',
    },
    controller: [
        'SocialConstants',
        'SocialLocaleService',
        class TradeExpandedComponent {
            constructor(SocialConstants,
                        SocialLocaleService) {
                this.constants = SocialConstants;
                this.translation = SocialLocaleService.translation;
            }

            $onInit() {

            }

            $onChanges(changes) {

            }

            $onDestroy() {

            }

        }]
})
